/**
 * Frontpage JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class PageFrontpage
 */
class Newsletter {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
        this.endpoint = 'https://info.pohjantahti.fi/l/1048172/2023-11-27/b8y';
    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.$NewsletterContainer = $( '#js-newsletter' );
        this.$NewsletterSubmit    = $( '#js-newsletter-submit' );
    }

    /**
     * All common events.
     *
     * @return {void}
     */
    events() {

        const thisClass = this;

        // Prevent form submission, this is handled with Ajax
        this.$NewsletterContainer.submit( function( e ) {

            e.preventDefault();

            const list  = $( '#js-newsletter .joinID' ).val();
            const email = $( '#js-newsletter #newsletter_email' ).val();

            thisClass.joinList( list, email );
        });
    }

    /**
     * Join to mailing lists.
     *
     * @return {void}
     */
    joinList( listID, email ) {

        const postData = {
            email: email,
            join: listID
        };

        const $NewsletterSuccess = $( '#js-newsletter-success' );
        const $NewsletterError = $( '#js-newsletter-error' );

        // Hide messages.
        $NewsletterError.addClass( 'hidden' );
        $NewsletterSuccess.addClass( 'hidden' );

        $.ajax({
            method: 'POST',
            url: ajaxurl,
            data: {
                action: 'salesforce_marketing_cloud_request',
                data: postData,
                endpoint: this.endpoint,
                nonce: nonce
            },
            success: function() {

                // Endpoint does not return any reasonable response.
                // We have to just trust that submission is ok when status is ok.
                // Show success message.
                $NewsletterSuccess.removeClass( 'hidden' );

                // Inform screen readers about success.
                 wp.a11y.speak( LocalData.newsletter_success, 'polite' );
            },
            error: function() {

                // Inform screen readers about error.
                wp.a11y.speak( LocalData.newsletter_error, 'polite' );

                // Show error message.
                $NewsletterError.removeClass( 'hidden' );

            }
        });
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}

// Export the class reference.
module.exports = Newsletter;



// WEBPACK FOOTER //
// ./assets/scripts/newsletter.js